import React from "react";
import Tooltip from "@material-ui/core/Tooltip";

const style = {
  display: "inline-flex",
  alignItems: "center",
  padding: "0px 6px",
  margin: "0px 4px",
  color: "white",
  background: "#1976d2",
  fontSize: 10,
  borderRadius: 16,
  height: 15,
};

function BetaBadge() {
  return (
    <Tooltip title="This LLM backed checklist is in Beta as we fine tune.">
      <span style={style}>Beta</span>
    </Tooltip>
  );
}

export default BetaBadge;
